import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    primary: { main: "#003366" },
    secondary: { main: "#1976d2" },
  },
  typography: {
    fontFamily: "Roboto, sans-serif",
  },
});

export default theme;
